import script from "./BaseSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./BaseSkeleton.vue?vue&type=style&index=0&id=1bca0529&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bca0529"]])

export default __exports__